<div class="sticky-header">
  <app-top-bar title="ORDER.TITLE"></app-top-bar>
  <div class="tabs-row">
    <div class="view-tabs mx">
      <div class="tab" [ngClass]="{ active: activeView === 'current' }" (click)="setActiveView('current')">
        <span>{{ 'ORDER.ORDERS' | translate }}</span>

      </div>
      <div class="tab" [ngClass]="{ active: activeView === 'previous' }" (click)="setActiveView('previous')">
        <span>{{ 'ORDER.PREVIOUS' | translate }}</span>
      </div>
    </div>
  </div>
</div>

@if (shouldShowBill) {
  <div class="page">
    @if (activeView === 'current') {
      @if (billedOrders?.length > 0) {
        <app-order-list [orders]="billedOrders"></app-order-list>

        <div class="order-summary border-top-line">
          @if (subtotal > 0) {
            <div>
              <span>{{ 'ORDER.SUBTOTAL' | translate }}</span>
              @if (subtotal > 0) {
                <span>{{ subtotal | currencySpace }}</span>
              }
            </div>
          }
          @if (discountAmount > 0) {
            <div>
              <span class="label">{{ 'VOUCHER.VOUCHER' | translate }}</span>
              <span class="amount">
                {{ -discountAmount | currencySpace }}
                <span class="default-currency">
                  {{ -discountAmount | currencySpace:true }}
                </span>
              </span>
            </div>
          }
          <!-- Fees -->
          @if (fees?.length > 0) {
            @for (fee of fees; track fee) {
              <div>
                <span class="label ">
                  {{ fee.name }}
                </span>
                <span class="amount">
                  {{ fee.amount | currencySpace }}
                  <span class="default-currency">
                    {{ fee.amount | currencySpace:true }}
                  </span>
                </span>
              </div>
            }
          }
          <!-- Final total in case of fees or vouchers -->
          @if (discountAmount > 0 || feesAmount > 0) {
            <div>
              <span class="label">{{ 'ORDER.TOTAL' | translate }}</span>
              <span class="amount">
                {{ finalTotal | currencySpace }}
                <span class="default-currency">
                  {{ finalTotal | currencySpace:true }}
                </span>
              </span>
            </div>
          }
          <!-- Balance Voucher -->
          @if (appliedVoucher?.mode === VoucherMode.Balance && isOrderFree && discountAmount > 0) {
            <div>
              <span class="label">{{ 'VOUCHER.REMAINING_BALANCE' | translate }}</span>
              <span class="amount">
                {{ appliedVoucher.amount - subtotal  | currencySpace }}
                <span class="default-currency">
                  {{ appliedVoucher.amount - subtotal | currencySpace:true }}
                </span>
              </span>
            </div>
          }
        </div>
      } @else if (!isLoading) {
        <div class="empty-page">{{ 'ACTIONS.EMPTY' | translate }}</div>
      }
    }

    <!-- Previous orders AKA paid -->
    @if (activeView === 'previous') {
      @if (paidOrders?.length > 0) {
        <app-order-list [orders]="paidOrders"></app-order-list>

        <div class="order-summary border-top-line">
          @if (paidSubtotal > 0) {
            <div>
              <span>{{ 'ORDER.SUBTOTAL' | translate }}</span>
              <span>{{ paidSubtotal | currencySpace }}</span>
            </div>
          }
          @if (paidDiscountAmount > 0) {
            <div>
              <span class="label">{{ 'VOUCHER.VOUCHER' | translate }}</span>
              <span class="amount">
                {{ -paidDiscountAmount | currencySpace }}
                <span class="default-currency">
                  {{ -paidDiscountAmount | currencySpace:true }}
                </span>
              </span>
            </div>
          }
          <!-- Fees -->
          @if (paidFees?.length > 0) {
            @for (fee of paidFees; track fee) {
              <div>
                <span class="label ">
                  {{ fee.name }}
                </span>
                <span class="amount">
                  {{ fee.amount | currencySpace }}
                  <span class="default-currency">
                    {{ fee.amount | currencySpace:true }}
                  </span>
                </span>
              </div>
            }
          }
          <!-- Final total -->
          @if (paidDiscountAmount > 0 || paidFeesAmount > 0) {
            <div>
              <span class="label">{{ 'ORDER.TOTAL' | translate }}</span>
              <span class="amount">
                {{ paidFinalTotal | currencySpace }}
                <span class="default-currency">
                  {{ paidFinalTotal | currencySpace:true }}
                </span>
              </span>
            </div>
          }
        </div>
      } @else if (!isLoading) {
        <div class="empty-page">{{ 'ACTIONS.EMPTY' | translate }}</div>
      }
    }
    
    @if (activeView === 'current') {
      @if (showAskBill) {
        <app-voucher-form (voucherApplied)="onVoucherApplied($event)" [(hideVoucher)]="hideVoucher" [(voucher)]="voucher" />
        
        <app-payment-options-sheet
          [paymentMethods]="paymentMethods"
          [disabled]="isLoading || submitted"
          (optionSelected)="onPaymentSelected($event)">
        </app-payment-options-sheet>
      }
      @if (isOrderFree) {
        <button class="btn"  (click)="submit()" [disabled]="submitted ? 'disabled' : null">
          <span>
            {{ 'BILL.PAY_BILL' | translate }}
          </span>
        </button>
      }
    }
  </div>
}

<app-loader-overlay [active]="isLoading" />
